import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import NavBar from './components/NavBar';
import Footer from './components/Footer';
import { Box } from '@mui/material';
// Pages
import Home from './pages/Home';
import Features from './pages/Features';
import Download from './pages/Download';
import FAQ from './pages/FAQ';
import Contact from './pages/Contact';
import About from './pages/About';
import PrivacyPolicy from "./policies/DisplayPrivacy"
import TermsConditions from "./policies/DisplayTerms";
import PrivacyPolicyGreenSpot from "./policies/DisplayPrivacyGreenSpot";
import DreamMap from './pages/DreamMap'; // if needed

function AppLayout() {
  const location = useLocation();
  const hideNavFooter = location.pathname.startsWith('/map/'); // example

  return (
    <>
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      {!hideNavFooter && <NavBar />}

      <Routes sx={{ vh: '100vh' }}>
        <Route path="/" element={<Home />} />
        <Route path="/features" element={<Features />} />
        <Route path="/download" element={<Download />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<About />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsConditions />} />
        <Route path="/map/:mapId" element={<DreamMap />} />
        <Route path="/privacy-greenspot" element={<PrivacyPolicyGreenSpot />} />
      </Routes>
    </Box>
      {!hideNavFooter && <Footer />}
    </>
  );
}

function App() {
  return (
    <Router> 
      <AppLayout />
    </Router>
  );
}

export default App;

